import { readStoredValue, removeStoredValue, writeStoredValue } from "../../lib/storage";

const COMMAND_CENTER_WORKSPACE_FILTER_KEY = "forge:command-center:workspace-filter";
const COMMAND_CENTER_WORKSPACE_FILTER_EVENT = "forge:command-center:workspace-filter-updated";

interface WorkspaceFilterChangeDetail {
  workspaceId: string | null;
}

function normalizeWorkspaceId(value: string | null): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function readStoredWorkspaceFilter(): string | null {
  return normalizeWorkspaceId(readStoredValue(COMMAND_CENTER_WORKSPACE_FILTER_KEY));
}

export function writeStoredWorkspaceFilter(workspaceId: string | null): void {
  if (typeof window === "undefined") return;

  const normalized = normalizeWorkspaceId(workspaceId);
  if (normalized === null) {
    removeStoredValue(COMMAND_CENTER_WORKSPACE_FILTER_KEY);
  } else {
    writeStoredValue(COMMAND_CENTER_WORKSPACE_FILTER_KEY, normalized);
  }

  window.dispatchEvent(
    new CustomEvent<WorkspaceFilterChangeDetail>(COMMAND_CENTER_WORKSPACE_FILTER_EVENT, {
      detail: { workspaceId: normalized },
    }),
  );
}

export function subscribeStoredWorkspaceFilter(
  listener: (workspaceId: string | null) => void,
): () => void {
  if (typeof window === "undefined") return () => {};

  const handleStorage = (event: StorageEvent) => {
    if (event.key !== COMMAND_CENTER_WORKSPACE_FILTER_KEY) return;
    listener(normalizeWorkspaceId(event.newValue));
  };

  const handleCustom = (event: Event) => {
    const customEvent = event as CustomEvent<WorkspaceFilterChangeDetail>;
    listener(normalizeWorkspaceId(customEvent.detail?.workspaceId ?? null));
  };

  window.addEventListener("storage", handleStorage);
  window.addEventListener(COMMAND_CENTER_WORKSPACE_FILTER_EVENT, handleCustom);
  return () => {
    window.removeEventListener("storage", handleStorage);
    window.removeEventListener(COMMAND_CENTER_WORKSPACE_FILTER_EVENT, handleCustom);
  };
}
